import { render, staticRenderFns } from "./ReferenceNumberLine.vue?vue&type=template&id=08a03c1b&scoped=true"
import script from "./ReferenceNumberLine.vue?vue&type=script&lang=ts"
export * from "./ReferenceNumberLine.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a03c1b",
  null
  
)

export default component.exports